"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _FormOptionChip = require("./FormOptionChip.styles");
var _theme = require("../utils/theme");
var _excluded = ["theme", "children", "label", "isSelected", "onChange"];
var FormOptionChip = function FormOptionChip(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    children = _ref.children,
    label = _ref.label,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    onChange = _ref.onChange,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_FormOptionChip.Chip, (0, _extends2["default"])({
    isSelected: isSelected,
    onClick: onChange
  }, props), label));
};
var _default = exports["default"] = FormOptionChip;